import * as tocbot from 'tocbot';

window.addEventListener('DOMContentLoaded', (event) => {
    tocbot.init({
        tocSelector: '.toc',
        contentSelector: '.toc-target',
        headingSelector: 'h2',
        activeLinkClass: 'active-link',
        orderedList: true,

    });
});